import type { RutaProd } from "../../../../runtime/rutas";
export default {
  "ruta": "/sistema/cedis/orders",
  "documento": "cedis",
  "acceso": "sesion",
  "filas": [
    "044"
  ],
  "cita": "Areas/CEDIS/Controllers/OrdersController.cs"
} satisfies RutaProd;
